import * as React from 'react'
import PageWrap from '../components/press/page-wrap'
import PressList from '../components/press/press-list'
import OGInfo from '../components/ui/og-info'
import { graphql } from 'gatsby'

const IndexPage = ({
  data: {
    allStrapiPress: { nodes }
  }
}) => {
  return (
    <PageWrap title='Press' id='startPoint'>
      <PressList data={nodes} />
    </PageWrap>
  )
}

export default IndexPage

export const Head = () => {
  return (
    <>
      <OGInfo
        title='The Henry | Upper West Side New Development by Naftali Group'
        description='Stay updated with the latest news and press coverage about The Henry Residences at 211 W 84th St. Discover why this UWS new development is making headlines.'
      />
    </>
  )
}

export const query = graphql`
  query PressQuery {
    allStrapiPress(sort: { PublicationDate: DESC }) {
      nodes {
        Title
        Slug
        Publisher
        Autor
        PublicationDate
        HeroImage {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
            publicURL
          }
          mime
        }
        OriginalURL
        id
        Copy {
          data {
            Copy
          }
        }
      }
    }
  }
`
